import React, { useState } from 'react'
import PropTypes from 'prop-types'
import useHandleMortgageBrokerResponse from 'Hooks/useHandleMortgageBrokerResponse'
import {
  MODAL_TYPE,
  SL_GATE,
} from 'Defaults/modals'
import {
  _Title,
  _PreApprovedCTA,
  _PreApprovedContainer,
  _SpeakToExpertCTA,
  _MyAbodeMortgage,
} from './styles'
import { strToNum } from '../../constant'

const PreApproved = ({
  openModal,
  unitPrice,
  downPayment,
  address,
  mobileContainer = false,
  rentalListing = false,
  userIsAuthentificated,
  user,
  contactBrokerSuccess,
  contactMortgageBroker,
  contactBrokerFailure,
  contactBrokerMsg,
  mls,
  isFetching,
}) => {
  const { first, last, email, phone, phoneCountryCode: userCode } = user || {}
  const [buttonClicked, setButtonClicked] = useState(false)

  let downPaymentVal = downPayment
  if(typeof downPayment === 'string') {
    downPaymentVal = Number(downPaymentVal.replace(/,/g, ''))
  }

  useHandleMortgageBrokerResponse({
    contactBrokerSuccess,
    contactBrokerFailure,
    contactBrokerMsg,
    buttonClicked,
    setButtonClicked,
    userIsAuthentificated,
  })

  const preApprovedWorkflow = (e) => {
    e.preventDefault()
    if(!userIsAuthentificated) {
      openModal({
        modalType: MODAL_TYPE.LOGIN,
        modalData: { gate: SL_GATE.MORTGAGE_CALC },
      })
    } else {
      setButtonClicked(true)
      contactMortgageBroker({
        first_name: first,
        last_name: last,
        request_type: 'GET_PRE_APPROVED',
        email,
        mls_number: mls || 'default',
        phone,
        phone_country_code: userCode,
        gate: SL_GATE.MORTGAGE_CALC,
        purchase_price: strToNum(unitPrice),
        down_payment: downPaymentVal,
        address,
      })
    }
  }

  return (
    <_PreApprovedContainer
      mobileContainer={mobileContainer}
      rentalListing={rentalListing}
    >
      <_Title>Looking for the best mortgage rates in Canada?</_Title>
      <_PreApprovedCTA
        primary
        onClick={e => preApprovedWorkflow(e)}
        loading={buttonClicked && isFetching}
        disabled={buttonClicked && isFetching}
      >
        Get Pre-Approved
      </_PreApprovedCTA>
      <_SpeakToExpertCTA
        secondary
        onClick={e => {
          e.preventDefault()
          openModal({
            modalType: MODAL_TYPE.MORTGAGE_BROKER,
            modalData: {
              unitPrice,
              downPayment,
              address,
              mls,
            },
          })
        }}
      >
        Speak with an Expert
      </_SpeakToExpertCTA>
      <_MyAbodeMortgage>
        <span>powered by&nbsp;</span>
        <img
          src={'/static/images/mortgages/myabode-mortgage-logo-dark.png'}
          alt="myabode logo"
        />
      </_MyAbodeMortgage>
    </_PreApprovedContainer>
  )
}
PreApproved.propTypes = {
  openModal: PropTypes.func,
  unitPrice: PropTypes.number,
  downPayment: PropTypes.number,
  address: PropTypes.string,
  mobileContainer: PropTypes.bool,
  rentalListing: PropTypes.bool,
  user: PropTypes.shape({}),
  contactBrokerSuccess: PropTypes.bool,
  contactMortgageBroker: PropTypes.func,
  userIsAuthentificated: PropTypes.bool,
  mls: PropTypes.string,
  contactBrokerFailure: PropTypes.bool,
  contactBrokerMsg: PropTypes.string,
  isFetching: PropTypes.bool,
}

export default PreApproved
